import { eachDayOfInterval, endOfMonth, format, startOfMonth } from 'date-fns'

import type { ChartDataPoint } from '@/components/ui'
import type { CreditBankEntry } from '@/modules/account/types'
import { toCalendarDate } from '@/utils'

const localDay = (isoDate: string) => toCalendarDate(new Date(isoDate))

const consumedPerDay = (entries: CreditBankEntry[]) =>
  entries.reduce<Map<string, number>>((totals, entry) => {
    if (entry.reason !== 'consumption') return totals
    const day = localDay(entry.createdAt)
    totals.set(day, (totals.get(day) ?? 0) + Math.abs(entry.deltaCredits))
    return totals
  }, new Map())

export const consumedByDay = (
  entries: CreditBankEntry[],
  month: Date,
): ChartDataPoint[] => {
  const totals = consumedPerDay(entries)
  const days = eachDayOfInterval({
    start: startOfMonth(month),
    end: endOfMonth(month),
  })

  return days.map((day) => {
    const date = format(day, 'yyyy-MM-dd')
    return {
      date,
      value: totals.get(date) ?? 0,
      formattedDate: format(day, 'MMM d'),
    }
  })
}
